import { $, owlCarousel } from "./imports";

const linkedinHome = () => {

    if($('.linkedin-home__list').length > 0){
        $('.linkedin-home__list .view-linkendin-cards-home > .view-content').addClass('owl-carousel').owlCarousel({
            nav: false,
            dots: true,
            navText: [
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M15.514,6l1.627,1.627-5.285,5.3,5.285,5.3-1.627,1.627L8.59,12.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>',
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M10.217,6,8.59,7.627l5.285,5.3L8.59,18.22l1.627,1.627,6.923-6.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>'
            ],
            // rewind: true,
            loop: true,
            autoplay: true,
            autoplayTimeout: 8000,
            autoplayHoverPause: true,
            // center: true,
            responsive: {
                0: {
                    items: 1,
                    stagePadding: 9,
                    margin: 11,
                },
                768: {
                    items: 2,
                    margin: 20,
                    stagePadding: 0,
                },
                992: {
                    nav: true,
                    items: 3,
                    margin: 20,
                },
                1200:{
                    nav: true,
                    items: 3,
                    margin: 40,
                }
            },
        });

        $('.linkedin-home__list .view-linkendin-cards-home > .view-content').trigger("refresh.owl.carousel");
        
    }
}

export default linkedinHome;